class Attach {

    constructor() {
        this.element = '#personalizator__attachment';
        this.attachments = [];
        this.bindEvent();
    }

    bindEvent() {

        $(document).ready(() => {

            $(this.element).on('change', (event) => {
                if ($(this.element).prop('files')[0]) {

                    let form = new FormData(); 
                    form.append('file', $(this.element).prop('files')[0]);
                    form.append('guid', $('#personalizator__guid').val());

                    $.ajax({
                        url: '/personalizacja/uploadAttachment/',
                        dataType: 'text',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,                         
                        type: 'post',
                        success: (response) => {
                            
                            response = JSON.parse(response);

                            if (response.error) {
                                this.showErrorOnUploadAttachment();
                                return false;
                            }

                            $(this.element).parent().parent().find('ol').append(`<li>${response.file}</li>`);

                            this.attachments.push(response.file);
                            this.updateElemet();

                        },
                        fail: (response) => {
                            this.showErrorOnUploadAttachment();
                            return false;
                        }
                    });

                }
            })

        });

    }

    showErrorOnUploadAttachment() {
        let item = $(this.element.inputAttachment).parent().parent().find('.fail');

        item.slideUp();

        setTimeout(() => {
            
            item.slideDown();

        }, 1000);
    }

    updateElemet() {

        $(this.element).data('attachments', JSON.stringify(this.attachments));

    }

}

export default new Attach();